import { render } from "./StallionTable.vue?vue&type=template&id=63efe38d"
import script from "./StallionTable.vue?vue&type=script&lang=js"
export * from "./StallionTable.vue?vue&type=script&lang=js"

import "./StallionTable.vue?vue&type=style&index=0&id=63efe38d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__